(() => {
'use strict';
if (window.crSocksInstalled) return;
window.crSocksInstalled = true;
const config = {"code":"PICKAPAIR","title":"Your socks are on us","eligible":[7588957847645,7681041072221,7884513607773,7940963041373,8008141865053,8031655428189,8032762396765,8032779599965,8082106450013,8082107367517,8107724767325,8121842335837,8121867698269,8121968951389,8121994412125,8172671926365,8172706627677,8172709642333,8189639852125,8232476999773,8234195746909,15412538146909,15412604174429,15412638777437,15459341074525],"socks":[{"name":"Tulum","handle":"royal-socks","id":44335356575837,"image":"https://cdn.shopify.com/s/files/1/0608/1770/3005/files/1668DDE0-F588-4B1B-853E-B46A0E613450.jpg?v=1789752954"},{"name":"Palma","handle":"palma-🌴-sock-size-7-11us","id":43888497786973,"image":"https://cdn.shopify.com/s/files/1/0608/1770/3005/files/IMG-0426.jpg?v=1765506289"},{"name":"Sangría","handle":"sangria-socks-size-7-11-us","id":45072832987229,"image":"https://cdn.shopify.com/s/files/1/0608/1770/3005/files/06E152BF-6519-4E07-9912-DF8F5534C9E6.jpg?v=1789753392"},{"name":"Verde","handle":"verde-sock-size-7-11","id":45072878796893,"image":"https://cdn.shopify.com/s/files/1/0608/1770/3005/files/920495EB-169B-4EE1-B5B9-02A319BBE6B4.jpg?v=1789755013"}]};
const dialog = document.getElementById('cr-socks-dialog');
if (!dialog) return;
const strings = JSON.parse(document.getElementById('cr-socks-strings').textContent);
const grid = dialog.querySelector('[data-sock-grid]');
const status = dialog.querySelector('[data-sock-status]');
const root = window.Shopify?.routes?.root || '/';
let busy = false, timer, dismissed = false, previousFocus;
const endpoint = async (path, body) => {
  const response = await fetch(root + path, body ? {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(body)
  } : {});
  const data = await response.json();
  if (!response.ok || data.status >= 400) throw new Error(data.description || strings.error);
  return data;
};
const qualifies = cart => cart.items.some(item => config.eligible.includes(item.product_id));
const gifts = cart => cart.items.filter(item => item.properties?._cr_complimentary_sock === 'PICKAPAIR');
const codes = cart => (cart.discount_codes || []).map(item => item.code).filter(Boolean);
const readCart = () => endpoint('cart.js');
const close = () => {
  if (busy) return;
  dialog.close();
  dismissed = true;
  previousFocus?.focus?.();
};
dialog.querySelector('[data-sock-close]').addEventListener('click', close);
dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
async function refreshCart() {
  const items = document.querySelector('cart-drawer-items, cart-items');
  if (items?.onCartUpdate) await items.onCartUpdate();
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    await publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cr-socks'});
  }
}
async function choose(sock) {
  if (busy) return;
  busy = true;
  grid.querySelectorAll('button').forEach(button => button.disabled = true);
  dialog.querySelector('[data-sock-close]').disabled = true;
  status.textContent = strings.adding;
  let addedKey, priorCodes = [];
  try {
    const before = await readCart();
    if (!qualifies(before)) throw new Error(strings.qualify);
    if (gifts(before).length) { busy = false; close(); return; }
    priorCodes = codes(before);
    const added = await endpoint('cart/add.js', {items:[{
      id: sock.id, quantity:1, properties:{_cr_complimentary_sock:'PICKAPAIR'}
    }]});
    addedKey = added.items?.[0]?.key;
    const updated = await endpoint('cart/update.js', {
      discount: [...new Set([...priorCodes, config.code])].join(',')
    });
    const gift = gifts(updated).find(item => item.variant_id === sock.id);
    const applied = gift?.discounts?.some(item =>
      [config.code, config.title].includes(item.title)
    ) || gift?.line_level_discount_allocations?.some(item =>
      [config.code, config.title].includes(item.discount_application?.title)
    );
    if (!gift || gift.final_line_price !== 0 || !applied) throw new Error(strings.unavailable);
    status.textContent = strings.success;
    dismissed = true;
    await refreshCart();
    busy = false;
    dialog.querySelector('[data-sock-close]').disabled = false;
    dialog.querySelector('[data-sock-close]').textContent = strings.done;
    grid.hidden = true;
  } catch (error) {
    if (addedKey) {
      try {
        await endpoint('cart/change.js', {id:addedKey,quantity:0});
        await endpoint('cart/update.js', {discount:priorCodes.join(',')});
        await refreshCart();
      } catch (_) {
        status.textContent = strings.review;
        busy = false;
        dialog.querySelector('[data-sock-close]').disabled = false;
        return;
      }
    }
    status.textContent = error.message || strings.error;
    busy = false;
    grid.querySelectorAll('button').forEach(button => button.disabled = false);
    dialog.querySelector('[data-sock-close]').disabled = false;
  }
}
async function inspect() {
  if (busy) return;
  busy = true;
  try {
    const cart = await readCart();
    if (!qualifies(cart)) {
      dismissed = false;
      for (const gift of gifts(cart)) {
        await endpoint('cart/change.js', {id:gift.key,quantity:0});
      }
      if (gifts(cart).length) await refreshCart();
      if (dialog.open) dialog.close();
      return;
    }
    if (gifts(cart).length || dismissed || dialog.open) return;
    const available = await Promise.all(config.socks.map(async sock => {
      try {
        const product = await endpoint('products/' + encodeURIComponent(sock.handle) + '.js');
        return product.variants.some(v => v.id === sock.id && v.available) ? sock : null;
      } catch (_) { return null; }
    }));
    const choices = available.filter(Boolean);
    if (!choices.length) return;
    grid.replaceChildren();
    grid.hidden = false;
    status.textContent = '';
    for (const sock of choices) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cr-sock-option';
      const image = document.createElement('img');
      image.src = sock.image;
      image.alt = '';
      image.width = 180;
      image.height = 180;
      image.loading = 'lazy';
      const label = document.createElement('span');
      label.textContent = sock.name;
      button.append(image,label);
      button.setAttribute('aria-label', strings.choose + ' ' + sock.name);
      button.addEventListener('click', () => choose(sock));
      grid.append(button);
    }
    previousFocus = document.activeElement;
    const drawer = document.querySelector('cart-drawer.active');
    if (drawer?.close) drawer.close();
    dialog.showModal();
  } catch (_) {
  } finally { busy = false; }
}
const schedule = () => {
  clearTimeout(timer);
  timer = setTimeout(inspect, 450);
};
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (event.source !== 'cr-socks') schedule();
  });
}
if (location.pathname.replace(/\/$/, '').endsWith('/cart')) schedule();
})();